(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zen-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zen-hero-rotation')) {
  customElements.define('zen-hero-rotation', class extends HTMLElement {
    connectedCallback() {
      if (this.running) return;
      this.running = true;
      this.epoch = (this.epoch || 0) + 1;
      this.word = this.querySelector('[data-hero-word]');
      this.stage = this.querySelector('.zen-rotation-images');
      this.button = this.querySelector('.zen-rotation-toggle');
      if (!this.word || !this.stage || !this.button) return;
      this.slides = [{word:this.dataset.firstWord,image:this.stage.querySelector('img')}];
      this.stage.querySelectorAll('template').forEach(template => this.slides.push({word:template.dataset.rotationWord,template}));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.inView = false;
      this.manualPause = false;
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.button.addEventListener('click', () => {
        this.manualPause = !this.manualPause;
        this.button.textContent = this.manualPause ? this.dataset.resume : this.dataset.pause;
        if (this.manualPause) {
          this.word.textContent = this.slides[this.index].word;
          this.arm(() => this.prepare(),3000);
        }
        this.resume();
      }, {signal:this.abort.signal});
      document.addEventListener('visibilitychange', () => this.resume(), {signal:this.abort.signal});
      this.motion.addEventListener('change', () => this.reset(), {signal:this.abort.signal});
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.resume();
      });
      this.observer.observe(this);
      this.reset();
    }
    disconnectedCallback() {
      this.running = false;
      this.epoch = (this.epoch || 0) + 1;
      clearTimeout(this.timer);
      this.abort?.abort();
      this.slides?.slice(1).forEach(slide => slide.image?.remove());
      this.observer?.disconnect();
      this.pending = null;
    }
    paused() {
      return !this.running || !this.inView || document.hidden || this.manualPause || this.motion.matches;
    }
    arm(fn, delay) {
      clearTimeout(this.timer);
      this.pending = {fn,delay};
      if (!this.paused()) this.timer = setTimeout(() => {this.pending = null; fn();}, delay);
    }
    resume() {
      clearTimeout(this.timer);
      if (this.pending && !this.paused()) this.arm(this.pending.fn, this.pending.delay);
    }
    reset() {
      clearTimeout(this.timer);
      this.pending = null;
      this.epoch += 1;
      this.index = 0;
      this.word.textContent = this.slides[0].word;
      this.slides.forEach((slide,index) => {
        slide.image?.classList.toggle('is-current',index === 0);
        slide.image?.setAttribute('aria-hidden',String(index !== 0));
      });
      this.button.hidden = this.motion.matches;
      if (!this.motion.matches) this.arm(() => this.prepare(), 3000);
    }
    async prepare() {
      const epoch = this.epoch;
      let next = (this.index + 1) % this.slides.length;
      let attempts = 0;
      while (this.slides[next].failed && attempts++ < this.slides.length) next = (next + 1) % this.slides.length;
      if (attempts >= this.slides.length) return;
      const slide = this.slides[next];
      if (!slide.image) {
        slide.image = slide.template.content.firstElementChild.cloneNode(true);
        slide.image.setAttribute('aria-hidden','true');
        this.stage.append(slide.image);
      }
      try { await slide.image.decode(); } catch (error) {
        if (!slide.image.naturalWidth) slide.failed = true;
      }
      if (!this.running || epoch !== this.epoch) return;
      if (slide.failed) {this.index = next; this.arm(() => this.prepare(), 3000); return;}
      const erase = () => {
        const chars = Array.from(this.word.textContent);
        if (chars.length) {
          chars.pop(); this.word.textContent = chars.join('');
          this.arm(erase,45);
        } else {
          this.slides.forEach((item,index) => {
            item.image?.classList.toggle('is-current',index === next);
            item.image?.setAttribute('aria-hidden',String(index !== next));
          });
          this.index = next;
          let count = 0;
          const letters = Array.from(slide.word);
          const type = () => {            this.word.textContent = letters.slice(0,++count).join('');
            if (count < letters.length) this.arm(type,80);
            else this.arm(() => this.prepare(),3000);
          };
          this.arm(type,80);
        }
      };
      this.arm(erase,45);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
